import {
  loanProjectionUrl,
  loansUrl,
  makeLoanPaymentUrlByLoandId,
  insuranceLoanUrl,
  createLoanContractUrl,
  applyDiscountUrl,
  createPromissoryNoteUrl,
  loanAppUrl,
  updateLoanUrl,
  checklistUrl,
  postChecklistUrl,
  deleteChecklistUrl,
} from '../constants/endpointUrls';

import Service from './Service';

const { REACT_APP_IBAN_API: ibanApi } = process.env;
class LoanService extends Service {
  getPaymentProjection(
    loanAmount,
    contractDurationInMonths,
    monthlyInterestRate,
    loanApplicationId,
    rating,
    monthsNoPay,
    withIVA
  ) {
    let params = {
      loanAmount: 0,
      contractDurationInMonths: 0,
      monthlyInterestRate: 0,
      contractStartDate: Date.now(),
      loanApplicationId,
      rating,
      monthsNoPay,
      withIVA,
    };

    if (loanAmount && contractDurationInMonths && monthlyInterestRate)
      params = {
        loanAmount,
        contractDurationInMonths,
        monthlyInterestRate,
        contractStartDate: Date.now(),
        loanApplicationId,
        monthsNoPay,
        rating,
        withIVA,
      };

    return this.getRequest(loanProjectionUrl, params);
  }

  /**
   * Request the loan object
   * @param {any} requestIdOrLoanId Request or loan id to request the loan object
   */
  getLoan(requestIdOrLoanId) {
    return this.getRequest(`${loansUrl}/${requestIdOrLoanId}`);
  }

  makePaymentByLoanId(loanId, amount, time) {
    const params = {
      amount,
      time,
    };
    return this.postRequest(makeLoanPaymentUrlByLoandId(loanId), params);
  }

  createLoanByRequestId(
    loanApplicationId,
    startTime,
    monthlyInterestRate,
    dailyLateChargeRate,
    contractDurationInMonths,
    gracePeriodInDays,
    legalPeriodInDays,
    amount
  ) {
    const params = {
      loanApplicationId,
      startTime,
      monthlyInterestRate,
      dailyLateChargeRate,
      contractDurationInMonths,
      gracePeriodInDays,
      legalPeriodInDays,
      amount,
      type: 'mortgage',
    };
    return this.postRequest(loansUrl, params);
  }

  getLoans(type = undefined, filter, page = 0) {
    if (!type) {
      const params = {
        ...filter,
        page,
      };
      return this.getRequest(loansUrl, params);
    }
    return this.getRequest(insuranceLoanUrl);
  }

  createLoanContract(values) {
    const params = {
      ...values,
      contractStartTime: values.contractStartTime.unix() * 1000,
      registrationTime: Date.now(),
    };

    return this.postRequest(createLoanContractUrl, params);
  }

  applyDiscountToDue(dueId, discountedAmount, loanId) {
    const params = {
      discountedAmount,
    };
    return this.postRequest(applyDiscountUrl(loanId, dueId), params);
  }

  createPromissoryNote(
    name,
    idCardNumber,
    contractDurationInMonths,
    monthlyFee,
    amount,
    address,
    registrationNumber,
    propertyDescription,
    purpose,
    contractStartTime,
    firstWitnessName,
    firstWitnessIdCardNumber,
    secondWitnessName,
    secondWitnessIdCardNumber,
    civilStatus
  ) {
    const params = {
      name,
      idCardNumber,
      contractDurationInMonths,
      monthlyFee,
      amount,
      address,
      registrationNumber,
      propertyDescription,
      purpose,
      contractStartTime: contractStartTime.unix() * 1000,
      registrationTime: Date.now(),
      firstWitnessName,
      firstWitnessIdCardNumber,
      secondWitnessName,
      secondWitnessIdCardNumber,
      civilStatus,
    };
    return this.postRequest(createPromissoryNoteUrl, params);
  }

  getLoanApplications(params, page = 0) {
    // eslint-disable-next-line no-param-reassign
    params.page = page;
    return this.getRequest(loanAppUrl, params);
  }

  setOwnerIdToLoan(ownerId, loanId) {
    const params = {
      ownerUserId: ownerId,
    };
    return this.patchRequest(updateLoanUrl(loanId), params);
  }

  getLoanApplicationsChecklist(id, country) {
    return this.getRequest(checklistUrl(id, country));
  }

  postLoanApplicationsChecklist(params) {
    const loanApplicationId = params.loan_application_id;
    return this.postRequest(postChecklistUrl(loanApplicationId), params);
  }

  deleteLoanApplicationsChecklist(loanId, taskId) {
    return this.deleteRequest(deleteChecklistUrl(loanId, taskId));
  }

  downloadPdfAmortization(params) {
    const obj = { ...params.params };
    return this.getRequest(`${ibanApi}/loans/projection-and-get-pdf/?`, obj);
  }
}

export default new LoanService();



// WEBPACK FOOTER //
// ./src/utils/services/LoanService.js